// ==========================================================================
// MAIN.JS - VITE ENTRY POINT FOR WURUPAYROLL
// ==========================================================================

import './styles.css';
import { jsPDF } from 'jspdf';
import './utils/sanitize.js';
import './utils/toast.js';

// Make jsPDF globally accessible for app.js legacy export handler
window.jspdf = { jsPDF };

// Register Service Worker for PWA installation
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then((reg) => {
        console.log('[PWA] Service Worker registered with scope:', reg.scope);
      })
      .catch((err) => {
        console.warn('[PWA] Service Worker registration failed:', err);
      });
  });
}

// Capture PWA beforeinstallprompt event
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPWAInstallPrompt = e;
  console.log('[PWA] beforeinstallprompt captured and ready');
  window.dispatchEvent(new CustomEvent('pwa-install-ready'));
});

// Import core application engine
import './app.js';
